module.exports = __webpack_public_path__ + "media/images/icon-question-mark-8c7276f84bd266e68359f3603e10e805.png";